
import { ConnectionProfile, connectionProfile } from "@/lib/constants";
import { profileOrganization } from "api/organizations";
import { getProfileProducts, getProfileSolutions } from "api/solutions";
import ProjectMultiStepModal from "components/Project/ProjectMultiStepModal";
import { useCoordinates } from "hooks/CoordinatesContext";
import { useOrganization } from "hooks/OrganizationContext";
import { useEffect, useState } from "react";
import { getOrganization as getOrganizationApi } from "api/organizations";
import ProjectListting from "./ProjectListting";
import ProjectsTableTabs from "./ProjectsTableTabs";
import { useJsApiLoader } from "@react-google-maps/api";

type Project = {
  id: string;
  name: string;
  desc: string;
  location: string;
  coordinates: [number, number] | null; // Nullable array of two numbers
  title: string;
  type: string; // Literal type
  bgColor: string;
  icon: string;
  status: string;
  link: string;
  isEditable: boolean;
};

const operationalExcelenceData = [
  {
    title: "EnergyHub",
    type: "FREE TRIAL",
    bgColor: "bg-[#2b5f8a]",
    icon: "/images/cpu.svg",
    status: "Public Project",
    link: "https://energyhub.processhub.ai/",
    desc: null,
    isEditable: false,
    isPrivate: false,
    createdAt: "2024-01-15"
  },
  {
    title: "Leap24",
    type: "FREE TRIAL",
    bgColor: "bg-[#2b5f8a]",
    icon: "/images/cpu.svg",
    status: "Public Project",
    link: "https://leap24.processhub.ai/",
    desc: null,
    isEditable: false,
    isPrivate: false,
    createdAt: "2024-02-20"
  },
  {
    title: "Data Center",
    type: "FREE TRIAL",
    bgColor: "bg-[#2b5f8a]",
    icon: "/images/cpu.svg",
    status: "Public Project",
    link: "https://datacenter.processhub.ai/",
    desc: null,
    isEditable: false,
    isPrivate: false,
    createdAt: "2024-03-10"
  },
  {
    title: "Water Tower",
    type: "FREE TRIAL",
    bgColor: "bg-[#2b5f8a]",
    icon: "/images/cpu.svg",
    status: "Public Project",
    link: "https://culturalhub.processhub.ai/",
    desc: null,
    isEditable: false,
    isPrivate: false,
    createdAt: "2024-04-05"
  },
  {
    title: "Car Simulator",
    type: "FREE TRIAL",
    bgColor: "bg-[#2b5f8a]",
    icon: "/images/cpu.svg",
    status: "Public Project",
    link: "https://car.processhub.ai/",
    desc: null,
    isEditable: false,
    isPrivate: false,
    createdAt: "2024-05-12"
  },
  {
    title: "EXPO2030",
    type: "FREE TRIAL",
    bgColor: "bg-[#2b5f8a]",
    icon: "/images/cpu.svg",
    status: "Public Project",
    link: "https://expo2030.processhub.ai/",
    desc: null,
    isEditable: false,
    isPrivate: false,
    createdAt: "2025-12-12"
  }
  // {
  //   title: "Energy Solution",
  //   type: "FREE TRIAL",
  //   bgColor: "bg-gradient-to-b from-green to-blue",
  //   icon: "/images/cpu.svg",
  //   status: "Public Project",
  //   link: "https://product.processhub.ai/o/0ed25137-caf2-42a0-bac0-4cd3e6b1bc8f/s/8ff5a48c-63ad-494b-a444-6e1173cf785c",
  //   desc: "Energy",
  //   isEditable: false,
  //   isPrivate: false 
  // }
  // {
  //   title: "SAAS",
  //   type: "FREE TRIAL",
  //   bgColor: "bg-gradient-to-b from-green to-blue",
  //   icon: "/images/cpu.svg",
  //   status: "Public Project",
  //   link: "https://product.processhub.ai/",
  //   isEditable: false
  // }
];


const initProject = {
  id: "",
  name: "",
  desc: "",
  location: "",
  coordinates: null,
  title: "",
  type: "PROJECT",
  bgColor: "",
  icon: "",
  status: "",
  link: "",
  isEditable: false,
};

interface ProjectHomeProps {
  type: string;
  setRefreshMode: React.Dispatch<React.SetStateAction<string>>;
  refreshMode: string;
  filters?: {
    duration: string;
    subscription: string;
    billingPeriod: string;
    paymentStatus: string;
    startDate: Date | null;
    endDate: Date | null;
    search: string;
  };
  activeProjectsTab: string;
  setActiveProjectsTab: (tab: string) => void;
  profileProducts: any;
  setProfileProducts: (products: any) => void;
}

const ProjectsTable: React.FC<ProjectHomeProps> = ({ type, setRefreshMode, refreshMode, filters, activeProjectsTab, setActiveProjectsTab, profileProducts, setProfileProducts }) => {
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const { selectedOrganization, setSelectedOrganization } = useOrganization();
  const [selectedProject, setSelectedProject] = useState<Project>(initProject);
  const [organizations, setOrganizations] = useState<any[]>([]);
  const [windowMode, setWindowMode] = useState<'projects' | 'newProject' | 'editProject' | 'newOrganization' | 'editOrganization'>('projects');
  const [newProjectModal, setNewProjectModal] = useState(false);
  const [allProjects, setAllProjects] = useState<any>([]);
  const [progressProjects, setProgressProjects] = useState<any>([]);
  // const [activeTab, setActiveTab] = useState('operational');
  const { setCoordinates } = useCoordinates();
  const [orgFormState, setOrgFormState] = useState({ id: '', name: '', desc: '' });
  // const [profileProducts, setProfileProducts] = useState<any>([]);
  const [markersLoaded, setMarkersLoaded] = useState(false);
  const [userProjects, setUserProjects] = useState<any>([]);
  const [projectFormState, setProjectFormState] = useState({
    projectName: "",
    productLocation: "",
    audience: "Public",
    building: "",
    description: "",
    coordinates: [null, null] as [number | null, number | null],
  });
  const [projectMode, setProjectMode] = useState<'create' | 'edit'>('create');
  const [step, setStep] = useState(1);
  const [orgStep, setOrgStep] = useState(1);
  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  const [isOrganizationWizardOpen, setIsOrganizationWizardOpen] = useState(false);
  const [organizationWizardMode, setOrganizationWizardMode] = useState<'create' | 'edit'>('create');
  const [selectedAsset, setSelectedAsset] = useState<string | null>(null);
  const [connectionProfiles, setConnectionProfiles] = useState<ConnectionProfile[]>(connectionProfile);
  const [isAgreementChecked, setIsAgreementChecked] = useState<boolean>(false);
  const [uploadBoxFilePreview, setUploadBoxFilePreview] = useState<string>("");
  const [isUnityExists, setIsUnityExists] = useState(false);
  const [showUploadZone, setShowUploadZone] = useState<boolean>(false);
  const handleAddNewOrganization = () => {
    setOrgFormState({ id: '', name: '', desc: '' });
    // setWindowMode('newOrganization');
    setIsOrganizationWizardOpen(true);
    setOrganizationWizardMode('create');
    setOrgFormState({ id: '', name: '', desc: '' });
  };

  const handleAddNewProject = () => {
    setCoordinates([0, 0]);
    setSelectedProject(initProject);
    setNewProjectModal(true);
    setProjectMode('create');
    setStep(1);
    setSelectedOption(null);
    setSelectedAsset(null);
    setIsAgreementChecked(false);
    setUploadBoxFilePreview("");
    setShowUploadZone(false);
    setProjectFormState({
      projectName: "",
      productLocation: "",
      audience: "Public",
      building: "",
      description: "",
      coordinates: [null, null] as [number | null, number | null],
    });
  };

  const checkUnityExists = () => {

    const userAgent = navigator.userAgent;
    // const userAgent = "Safar - google / mozilla /Unity";
    setIsUnityExists(userAgent.includes("Unity"));

  };

  useEffect(() => {
    if (!isUnityExists) {
      checkUnityExists();
    }
  }, [isUnityExists]);


  // Function to get Operational Excellence projects (currently using the main API)
  const getOperationalProjects = async (id: string) => {
    const response = await getProfileSolutions(id);
    if (response.status === 200) {
      const newProjects = response.data.list.map((item: any) => {
        return {
          ...item,
          title: item.name,
          type: "PROJECT",
          bgColor: "bg-gradient-to-b from-green to-blue",
          icon: "/images/cpu.svg",
          status: "Private Project",
          link: item.url,
          isEditable: true,
          createdAt: item.createdAt || item.created_at || new Date().toISOString().split('T')[0] // Add default date if not available
        };
      });

      selectedOrganization.id === '0ed25137-caf2-42a0-bac0-4cd3e6b1bc8f' ?
        setAllProjects([...operationalExcelenceData, ...newProjects]) :
        setAllProjects(newProjects);

      setIsLoading(false);
    }
    else {
      setError(response.data);
    }
  };

  // Function to get Progress Monitoring projects
  // Currently using the same API as Operational Excellence, but can be changed in the future
  const getProgressProjects = async (id: string) => {
    const response = await getProfileSolutions(id);
    if (response.status === 200) {
      const newProjects = response.data.list.map((item: any) => {
        return {
          ...item,
          title: item.name,
          type: "PROJECT",
          bgColor: "bg-gradient-to-b from-green to-blue",
          icon: "/images/cpu.svg",
          status: "Private Project",
          link: item.url,
          isEditable: true,
          createdAt: item.createdAt || item.created_at || new Date().toISOString().split('T')[0] // Add default date if not available
        };
      });

      setProgressProjects(newProjects);
    }
    else {
      setError(response.data);
    }
  };

  // Main function to fetch all projects based on the active tab
  const getAllProjects = async (id: string) => {

    try {
      setIsLoading(true);

      // Get Operational Excellence projects
      await getOperationalProjects(id);

      // Get Progress Monitoring projects
      await getProgressProjects(id);

      setIsLoading(false);

      const response = await getProfileSolutions(id);
      if (response.status === 200) {
        const newProjects = response.data.list
          .map((item: any) => ({
            ...item,
            title: item.name,
            type: "PROJECT",
            bgColor: "bg-gradient-to-b from-green to-blue",
            icon: "/images/location-pin.png",
            status: "Private Project",
            link: item.url,
            isEditable: true,
            coordinates: item.coordinates ? JSON.parse(item.coordinates) : null
          }))
          .filter((project: any) => project.coordinates !== null);

        setUserProjects(newProjects);
      }
    } catch (error) {
      console.error("Error loading projects:", error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
      setMarkersLoaded(true);
    }
  };

  useEffect(() => {
    if (selectedOrganization?.id) {
      setIsLoading(true);
      getAllProjects(selectedOrganization.id);
      fetchProfileProducts(selectedOrganization.id);
      setWindowMode('projects');
    } 
  }, [selectedOrganization?.id]);

  useEffect(() => {
    if (organizations.length > 0 && !selectedOrganization?.id) {
      setSelectedOrganization(organizations[0]);
      setIsLoading(false);
    } 
  }, [organizations, selectedOrganization?.id]);

  // Add effect to trigger filtering when filters change
  useEffect(() => {
    // This will trigger a re-render with filtered data when filters change
  }, [filters]);

  const setOrganizationsList = async () => {
    const response = await profileOrganization();
    if (response.status === 200) {
      setOrganizations(response.data.list);
    }
    else {
      setError(response.data);
    }
  };

  const getOrganization = async () => {
    const response = await getOrganizationApi(selectedOrganization.id);
    if (response.status === 200) {
      setOrgFormState(response.data.data);
    }
    else {
      setError(response.data);
    }
  };
  const fetchProfileProducts = async (id: string) => {
    const response = await getProfileProducts(id);
    if (response.status === 200) {
      // Sort the products to ensure Operational Excellence is always first
      const sortedProducts = response.data.list.sort((a: any, b: any) => {
        if (a.name === "Operational Excellence") return -1;
        if (b.name === "Operational Excellence") return 1;
        if (a.name === "Progress Monitoring") return -1;
        if (b.name === "Progress Monitoring") return 1;
        return 0;
      });
      
      setProfileProducts(sortedProducts);
      if (isUnityExists) {
        setActiveProjectsTab(sortedProducts[1].id);
      } else {
        setActiveProjectsTab(sortedProducts[0].id);
      }
    }
    else {
      setError(response.data);
    }
  };


  const handleOrgEdit = () => {
    getOrganization();
    // setWindowMode('editOrganization');
    setIsOrganizationWizardOpen(true);
    setOrganizationWizardMode('edit');
  };

  const handleOrganizationWizardClose = () => {
    setIsOrganizationWizardOpen(false);
  };

  useEffect(() => {
    setOrganizationsList();
  }, []);

  useEffect(() => {
    if (selectedProject.id !== '') {
      // setWindowMode('editProject');
      setNewProjectModal(true);
      setProjectMode('edit');
    }
  }, [selectedProject]);

  useEffect(() => {
    if (refreshMode === 'organizations') {
      setOrganizationsList();
    }
    if (refreshMode === 'solutions' && selectedOrganization?.id) {
      getAllProjects(selectedOrganization.id);
      setSelectedProject(initProject);
      setWindowMode('projects');
    }
    setRefreshMode('');
  }, [refreshMode, selectedOrganization?.id]);


  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (selectedOrganization?.id) {
      setUserProjects([]);
      getAllProjects(selectedOrganization.id);
    }
  }, [selectedOrganization?.id, refreshMode]);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyCaAnlPllExl2Yuk5G6RENFb0zlBQUXFWY",
  });
  useEffect(() => {
    if (isLoaded) {
      setLoading(false);
    }
  }, [isLoaded, userProjects]);

  // Filter projects based on the filters
  const getFilteredProjects = (projects: any[], productName: string) => {
    if (!filters) return projects;
    
    let filtered = [...projects];
    
    // Apply date filter
    if (filters.startDate && filters.endDate) {
      const beforeCount = filtered.length;
      filtered = filtered.filter((project: any) => {
        // Use createdAt if available, otherwise use a default date
        const projectDate = project.createdAt ? new Date(project.createdAt) : new Date();
        const startDate = new Date(filters.startDate!);
        const endDate = new Date(filters.endDate!);
        
        // Set time to start of day for comparison
        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(23, 59, 59, 999);
        
        const isInRange = projectDate >= startDate && projectDate <= endDate;
        return isInRange;
      });
    }
    
    // Apply search filter
    if (filters.search) {
      const beforeCount = filtered.length;
      filtered = filtered.filter((project: any) => {
        const searchTerm = filters.search.toLowerCase();
        const matches = (
          project.title?.toLowerCase().includes(searchTerm) ||
          project.desc?.toLowerCase().includes(searchTerm) ||
          project.location?.toLowerCase().includes(searchTerm) ||
          project.status?.toLowerCase().includes(searchTerm)
        );
        return matches;
      });
    }
    
    return filtered;
  };

  // Get filtered projects for each category
  const getFilteredOperationalProjects = () => {
    return getFilteredProjects(allProjects, 'Operational Excellence');
  };

  const getFilteredProgressProjects = () => {
    return getFilteredProjects(progressProjects, 'Progress Monitoring');
  };

  if(loading){
    return <div>Loading...</div>;
  }

  return (
    <section
     
    >
      <div className="relative z-10">
 

    
            {windowMode === 'projects' && <ProjectsTableTabs
              activeTab={activeProjectsTab}
              onTabChange={setActiveProjectsTab}
              profileProducts={profileProducts}
              isUnityExists={isUnityExists}
            >
              {profileProducts.length > 0 ? profileProducts.map((product: any) => {

                return (
                  <div key={product.id} className="mt-4">
                    {activeProjectsTab === product.id && (
                      <ProjectListting
                        key={`${selectedOrganization?.id}-${product.id}`}
                        type={type}
                        activeTab={activeProjectsTab}
                        title={product.name}
                        data={(() => {
                          const filteredData = product?.name.includes('Operational Excellence') ? getFilteredOperationalProjects() : getFilteredProgressProjects();   
                          return filteredData;
                        })()}
                        handleAddNew={handleAddNewProject}
                        isDisabled={false}
                        isLoading={isLoading}
                        setSelectedProject={setSelectedProject}
                        productId={product.id}
                      />
                    )}
                  </div>
                );
              }
              ) : (
                <div className="flex justify-center items-center h-full">
                  <div className="text-white text-2xl font-bold">No projects found</div>
                </div>
              )}
            </ProjectsTableTabs>}
       
      </div>

      <ProjectMultiStepModal
      from={"projectsTab"}
        step={step}
        setStep={setStep}
        selectedOption={selectedOption}
        setSelectedOption={setSelectedOption}
        isLoading={isLoading}
        setNewProjectModal={setNewProjectModal}
        isOpen={newProjectModal}
        onClose={() => setNewProjectModal(false)}
        setRefreshMode={setRefreshMode}
        setError={setError}
        mode={projectMode}
        formState={projectFormState}
        setFormState={setProjectFormState}
        setIsLoading={setIsLoading}
        selectedOrganization={selectedOrganization}
        selectedProject={selectedProject}
        activeTab={activeProjectsTab}
        selectedAsset={selectedAsset}
        setSelectedAsset={setSelectedAsset}
        connectionProfiles={connectionProfiles}
        setConnectionProfiles={setConnectionProfiles}
        isAgreementChecked={isAgreementChecked}
        setIsAgreementChecked={setIsAgreementChecked}
        uploadBoxFilePreview={uploadBoxFilePreview}
        setUploadBoxFilePreview={setUploadBoxFilePreview}
        setShowUploadZone={setShowUploadZone}
        showUploadZone={showUploadZone}
      />
      {/* <OrganizationWizard orgStep={orgStep} setOrgStep={setOrgStep} isLoading={isLoading} setRefreshMode={setRefreshMode} setError={setError} orgFormState={orgFormState} setOrgFormState={setOrgFormState} setIsLoading={setIsLoading} mode={organizationWizardMode} isOrganizationWizardOpen={isOrganizationWizardOpen} handleOrganizationWizardClose={handleOrganizationWizardClose} /> */}
    </section>
  );
};

export default ProjectsTable;